import React, { useLayoutEffect, useRef } from "react";
import { Check } from "lucide-react";
import { fazeBarva, nazevEtapy, pipelineEtapy } from "../lib/faze";

/** Pás „kde to stojí" jede jen po pipeline (s mezikroky firmy mezi Nabídkou
 *  a Objednáno); dokončeno a ztraceno stojí mimo. Stejný na obchodním případu
 *  i na technologii (plátno 9F / 14B). `faze` = etapa (lib/faze.js). */

/** „14. 7." — u pásu fází stačí den a měsíc. */
function denMesic(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : `${d.getDate()}. ${d.getMonth() + 1}.`;
}

/**
 * Pás fází (9F ze schváleného plátna): šipky za sebou. Hotové a aktuální fáze
 * jsou v plné barvě své fáze, budoucí jen jemným nádechem — už dopředu je vidět,
 * kam případ půjde. Pás jen ukazuje: fáze případu = nejpomalejší technologie,
 * mění se kroky u technologií (s branami), ne kliknutím sem.
 * Pod každou šipkou je místo na datum vždycky, i když je prázdné — pás se nesmí lámat.
 */
export default function PasFazi({ faze, kdy = {} }) {
  const PIPELINE = pipelineEtapy();
  const stage = PIPELINE.indexOf(faze);
  const mimo = stage < 0;                    // dokončeno nebo ztraceno
  const posledni = PIPELINE.length - 1;
  // Na telefonu se pás nevejde — posouvá se jen do stran (ne nahoru a dolů)
  // a sám se posune tak, aby aktuální fáze byla vidět.
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || el.scrollWidth <= el.clientWidth) return;
    const krok = el.querySelector('[aria-current="step"]');
    if (krok) el.scrollLeft = Math.max(0, krok.offsetLeft - (el.clientWidth - krok.offsetWidth) / 2);
  }, [faze]);
  return (
    <div ref={ref} className="pas-fazi relative overflow-x-auto overflow-y-hidden overscroll-x-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
    <div className="flex min-w-[var(--pas-min)] md:min-w-0" data-testid="phase-bar"
      style={{ "--pas-min": `${Math.max(520, PIPELINE.length * 104)}px` }}>
      {PIPELINE.map((f, i) => {
        const done = mimo ? faze === "DOKONCENO" : i < stage;
        const active = !mimo && i === stage;
        const b = fazeBarva(f);
        const prvni = i === 0, konec = i === posledni;
        const tvar = prvni
          ? "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%)"
          : konec
            ? "polygon(0 0, 100% 0, 100% 100%, 0 100%, 12px 50%)"
            : "polygon(0 0, calc(100% - 12px) 0, 100% 50%, calc(100% - 12px) 100%, 0 100%, 12px 50%)";
        return (
          <div key={f} data-testid={`faze-krok-${f}`} aria-current={active ? "step" : undefined}
            className="flex-1 min-w-0 flex flex-col" style={{ marginLeft: prvni ? 0 : -6 }}>
            <span className="h-10 flex items-center justify-center gap-1 truncate text-[11.5px] md:text-[12px]"
              style={{
                clipPath: tvar, paddingLeft: prvni ? 10 : 18, paddingRight: 12,
                background: done || active ? b.silna : "#f1f0ed",
                color: done || active ? "#ffffff" : "#9a9ea5",
                fontWeight: active ? 700 : 600,
                transition: "background-color .3s ease, color .3s ease",
              }}>
              {done && <Check size={12} strokeWidth={3.2} className="shrink-0" />}
              <span className="truncate">{nazevEtapy(f)}</span>
            </span>
            <span className="mt-1 h-[14px] text-center amount text-[10px] text-muted-2">
              {done || active ? denMesic(kdy[f]) : ""}
            </span>
          </div>
        );
      })}
    </div>
    </div>
  );
}

